export var Context;
(function(Context) {
    Context["SEARCH_ALERTS_SERVICE"] = "search-alerts";
    Context["SEARCH_SUGGEST_SERVICE"] = "search-suggest";
    Context["SEARCH_SIMILAR_SERVICE"] = "search-similar";
    Context["SQUAD"] = "search";
    Context["COMPARE_SERVICE"] = "compare";
    Context["SEARCH_PART_EX_SERVICE"] = "search-part-exchange";
    Context["SEARCH_SEO_POPULAR_LINKS"] = "search-seo-popular-links";
    Context["SEARCH_FAQ_STORYBLOK_CONTENT"] = "search-faq-storyblok-content";
    Context["SEARCH_STORYBLOK_INTRO_CONTENT"] = "search-storyblok-intro-content";
    Context["SEARCH_OUTRO_CONTENT"] = "search-buying-guide";
    Context["SEARCH_FILTER_SELECTED"] = "search-filter-selected";
})(Context || (Context = {}));
